import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  constructor(private breakpointObserver: BreakpointObserver) {}

  maxWidth(size: number): Observable<boolean> {
    return this.breakpointObserver
      .observe([`(max-width: ${size}px)`])
      .pipe(map((state) => state.matches));
  }

  minWidth(size: number): Observable<boolean> {
    return this.breakpointObserver
      .observe([`(min-width: ${size}px)`])
      .pipe(map((state) => state.matches));
  }
}
